// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Notifications_overlay__1aVw4","badge":"Notifications_badge__2zVeW","icon":"Notifications_icon__3l2Rd"};